import React from "react";

export default function LearnVitamins() {
  return (
    <div>
      {/* 🔹 Banner Section */}
      <section
        style={{
          backgroundImage: "url('/images/AboutOrgavitaz/learn-vitamins.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "70vh",
          position: "relative", // ✅ Needed for absolute positioning inside
          marginBottom: "3rem",
          color: "#fff",
        }}
      >
        {/* Banner Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        ></div>

        {/* Title at bottom of banner */}
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0,0,0,0.5)",
            padding: "1rem 2rem",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          <h1 className="display-6 m-0">Learn Vitamins</h1>
        </div>
      </section>

      {/* 🔹 Book-style Sections */}
     <section className="container my-5">

  {/* 🔹 Section 1 (Full Text) */}
  <div className="mb-5">
    <h1 className="text-center mb-3">Learn Vitamins</h1>
    <h3 className="text-center mb-3">Synthetic Vs Natural Vs Whole-Food Bio-Format</h3>
    <p>
      Generally Marketed Vitamins are compounds or single chemicals essential in
       small quantities for normal growth and development of bodily functions of human.
        Vitamin compounds can be synthesized, in high concentrates (high potency).
         This is the principle followed by most supplement manufacturers, 
         the majority of which are pharmaceutical companies. These vitamins are termed “synthetic”.
          (Though they can be labeled “natural” even if they come from sugar or coal tar or petroleum).
    </p>
  </div>

  {/* 🔹 Section 2 (Text Left, Image Right) */}
  <div className="row align-items-center mb-5">
    <div className="col-md-6 p-3">
     <p>Vitamins and mineral elements are so complex,
       and have so many parts that are dependent upon each other, 
       that when separated they no longer can produce a normal nutritional
        effect on the body. According to this theory, an overdose of any one vitamin,
         as it occurs with separated out or synthetic vitamins, can be hazardous to the body.
          Complete vitamins, with all of their parts and necessary cofactors are often termed
           “whole-food vitamins”, since they are derived entirely from whole foods.</p>
      <p>A vitamin consists of “organic nutrient(s) identified not just as the vitamin,
         but also enzymes, coenzymes, antioxidants and trace element activators.” 
         A vitamin complex is not simply an individual chemical or several chemicals.
          It must contain all factors that make up the vitamin function in its entirety.</p>     
    </div>
    <div className="col-md-6 p-3">
      <img
        src="/images/AboutOrgavitaz/learn-vitamins.jpg"
        alt="Our Core Strengths"
        className="img-fluid rounded"
        style={{ width: "100%", height: "350px", objectFit: "cover" }}
      />
    </div>
  </div>

  {/* 🔹 Section 3 (Image Left, Text Right) */}
  <div className="row align-items-center flex-row-reverse mb-5">
    <div className="col-md-6 p-3">
    
      <ul>
        <li>Synthetic Vitamins usually represent exponentially higher RDAs,
           which is practically not feasible from whole-food complexes.</li>
        <li>Synthetic vitamins are primarily sourced from petroleum products
           or fossil fuels and are artificially isolated through an industrial process.</li>
        <li>Synthetic added to supplements for increasing the stability of the vitamin
           or mineral. Some of the salt forms to look for include acetate, bitartrate,
            chloride, gluconate, hydrochloride, nitrate and succinate.</li>
        <li>Synthetic Multis represent a specific chemically stable salt form and their 
          bioavailability is very less and requires bodily transformations for absorption.</li>
        <li>USP grade and Pharma grade vitamins are obvious formats, ‘dl’ in an ingredient represents
           synthetic that can be recognised for falsification with natural and whole-food forms.
            Not all synthetic vitamins are easily absorbed by the body, which is not the case with whole-food.</li>
        <li>For instance, when we use the word Ascorbic acid, we definitely may not mean whole-food, instead a most definite synthetic form.</li>
      </ul>
    </div>
    <div className="col-md-6 p-3">
      <img
        src="/images/AboutOrgavitaz/About_Orgavitaz-Banner.jpg"
        alt="Global Presence"
        className="img-fluid rounded"
        style={{ width: "100%", height: "350px", objectFit: "cover" }}
      />
    </div>
  </div>

  {/* 🔹 Section 4 (helloText Left, Image Right) */}
  
   <div className="mb-5">
    <h1 className="text-center mb-3">Misleading natural Claims</h1>
      <ul>
        <li>Many occasions ‘Natural’ claims are misleading.
           Because even 10% of natural ingredients comes with a claim of natural.</li>
           <li>Natural sources may not be fully beneficial, when the process is
             artificial and industrial chemical interventions are in place.
              Ingredients derived from Natural sources (plant or animal) may not
               be essentially natural ingredients, when isolated, purified and
                stabilized chemically.</li>
          <li>Chemically stable in most cases lead to a requirement biological
             transformation in liver for bioavailability inside the human body,
              eventually this situation leads to poor absorption and clinical impact.</li> 
          <li>So Natural ingredients are different from ‘made from natural ingredients.
             So almost like synthetic vitamins, even natural vitamins in its pure and
              isolated vitamers forms behave more like synthetic vitamins. However, 
              with a relatively minimal threats unlike synthetic supplements.</li>
          <li>A good natural supplement may not offer higher dosage, when the whole-food
             form is retained for bioavailability. Good natural products recognise the 
             significance of its whole-food form and retains it while processing or manages a non-chemical processing.</li>
        </ul>
  </div>

</section>

     
    </div>
  );
}
